module.exports = __webpack_public_path__ + "static/img/form_stehend1.c9be395f.png";